<template>
	<div class="confirmation" 
		:class="{
			'confirmation--main': this.step === 'confirm',
			'confirmation--loader': this.step === 'loader',
			'confirmation--success': this.step === 'success',
			'confirmation--sravni': this.page === 'sravni',
		}">
		<div class="confirmation__section confirmation__section--upper">
			<div class="confirmation__title" v-if="this.step === 'confirm' && this.page !== 'sravni'">
				Подтвердите ознакомление с&nbsp;документами
			</div>
			<div class="confirmation__title" v-if="this.step === 'confirm' && this.page === 'sravni'">
				Пожалуйста, подтвердите ознакомление с&nbsp;документами
			</div>
			<div class="confirmation__title"
				v-if="this.step === 'loader' && this.loaderType === 'invoice' && this.page !== 'sravni'">
				Подождите, <nobr>идет формирование счета</nobr>
			</div>
			<div class="confirmation__title"
				v-if="this.step === 'loader' && this.loaderType === 'simple' && this.page === 'sravni'">
				Пожалуйста, подождите
			</div>
			<div class="confirmation__title"
				v-if="this.step === 'loader' && this.loaderType === 'getPaylink' && this.page === 'sravni'">
				Пожалуйста, подождите, <nobr>идет переход на страницу оплаты</nobr>
			</div>
			<div class="confirmation__title"
				v-if="this.step === 'loader' && this.loaderType === 'contract' && this.page !== 'sravni'">
				Подождите, <nobr>идет формирование полиса</nobr>
			</div>
			<div class="confirmation__title"
				v-if="this.step === 'loader' && this.loaderType === 'contract' && this.page === 'sravni'">
				Пожалуйста, подождите, <nobr>идет формирование полиса</nobr>
			</div>
			<div class="confirmation__title" v-if="this.step === 'success'">
				Спасибо, <nobr>что выбрали МАКС-Жизнь!</nobr>
				<!-- {{ this.getTitle() }} -->
			</div>
		</div>

		<div class="confirmation__section confirmation__section--middle">
			<div class="confirmation__subtitle" v-if="this.step === 'confirm' && this.page !== 'sravni'">
				Введите код из СМС
			</div>
			<div class="confirmation__subtitle" v-if="this.step === 'confirm' && this.page === 'sravni'">
				Для подтверждения указанной информации и&nbsp;подписания КИД и&nbsp;полиса простой электронной подписью, пожалуйста, введите код из&nbsp;СМС
			</div>
			<div class="confirmation__numbers" v-if="this.step === 'confirm'">
				<clp-numbers :page="this.page" :msg="msgAlert" @inserted="numbersInserted"
					@sendAgain="this.$emit('sendAgain')"></clp-numbers>
			</div>

			<div class="confirmation__loading" v-if="this.step === 'loader'">
				<img class="confirmation__loading-img" src="@/create/assets/images/loading.png" alt="loading">
			</div>

			<div class="confirmation__descr" v-if="this.step === 'success'">
				Полис страхования жизни успешно оформлен и&nbsp;оплачен. Полис и комплект страховых документов направлены
				на&nbsp;указанный Вами адрес электронной почты.
			</div>
			<div class="confirmation__descr" v-if="this.step === 'success'">
				Также Вы можете скачать документы.
			</div>
			<div class="confirmation__download" v-if="this.step === 'success'">
				<button class="confirmation__button button button--unfilled">
					Скачать
				</button>
			</div>
			<div class="confirmation__descr" v-if="this.step === 'success'">
				Всю информацию о Вашей программе страхования Вы можете узнать по телефону нашей горячей линии <nobr><b>8 800
						333 90 13</b></nobr>.
			</div>

		</div>

		<div class="confirmation__section confirmation__section--bottom">
			<button v-if="this.step === 'confirm'" @click="this.$emit('closeDialog')"
				class="confirmation__button button button--unfilled button--outline-grey" :class="{
					'button--sravni-smaller': this.page === 'sravni',
				}">
				Назад
			</button>
			<button disabled v-if="this.step === 'confirm' && !this.confirmAvbl" class="confirmation__button button"
				:class="{
					'button--sravni-smaller': this.page === 'sravni',
				}">
				Подтвердить
			</button>
			<button v-if="this.step === 'confirm' && this.confirmAvbl" @click="this.$emit('checkNumbers')"
				class="confirmation__button button" :class="{
					'button--sravni-smaller': this.page === 'sravni',
				}">
				Подтвердить
			</button>
			<button v-if="this.step === 'success'" @click="this.$emit('closeDialog')" class="confirmation__button button" :class="{
				'button--sravni-smaller': this.page === 'sravni',
			}">
				Закрыть
			</button>
		</div>
	</div>
</template>

<script>
import ClpNumbers from '@/create/components/ClpNumbers.vue'

export default {
	props: ['page', 'step', 'loaderType', 'msgAlert', 'confirmAvbl'],
	components: {
		ClpNumbers
	},
	// data() {
	// 	return {			
	// 	};
	// },
	methods: {
		numbersInserted(numbers) {
			this.$emit('numbersInserted', numbers);
		},
		// getTitle() {
			// if (this.step === 'success') {
				// return `Спасибо, <nobr>что выбрали МАКС-Жизнь!</nobr>`
			// }
		// },
	},
}
</script>
<style lang="scss">
@import "@/create/assets/scss/style.scss";
</style>
